// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"933395f7","684":"14038222"}[chunkId] + ".chunk.js";
};